import React from 'react';
import { Briefcase, AlertTriangle, Users, MessageSquare, TrendingUp, PoundSterling, BarChart2, CheckCircle, Target } from 'lucide-react';

const kpis = [
  {
    id: 'kpi-jobs-today',
    label: 'Jobs Today',
    value: '14',
    sub: '+2 vs yesterday',
    trend: 'up',
    icon: Briefcase,
    color: 'bg-primary/10 text-primary',
    span: 'col-span-1',
  },
  {
    id: 'kpi-unassigned',
    label: 'Unassigned Jobs',
    value: '3',
    sub: 'Need cleaner assigned',
    trend: 'alert',
    icon: AlertTriangle,
    color: 'bg-danger-bg text-danger',
    span: 'col-span-1',
  },
  {
    id: 'kpi-active-cleaners',
    label: 'Active Cleaners',
    value: '8',
    sub: '3 in progress now',
    trend: 'neutral',
    icon: Users,
    color: 'bg-info-bg text-info',
    span: 'col-span-1',
  },
  {
    id: 'kpi-complaints',
    label: 'Open Complaints',
    value: '3',
    sub: '1 escalated',
    trend: 'alert',
    icon: MessageSquare,
    color: 'bg-warning-bg text-warning',
    span: 'col-span-1',
  },
  {
    id: 'kpi-revenue',
    label: 'Revenue This Week',
    value: '£4,820',
    sub: '+12% vs last week',
    trend: 'up',
    icon: TrendingUp,
    color: 'bg-success-bg text-success',
    span: 'col-span-1 lg:col-span-2',
  },
  {
    id: 'kpi-payout',
    label: 'Cleaner Payouts',
    value: '£2,940',
    sub: 'Due Friday',
    trend: 'neutral',
    icon: PoundSterling,
    color: 'bg-primary/10 text-primary',
    span: 'col-span-1',
  },
  {
    id: 'kpi-profit',
    label: 'Gross Profit',
    value: '£1,880',
    sub: '39% margin',
    trend: 'up',
    icon: BarChart2,
    color: 'bg-success-bg text-success',
    span: 'col-span-1',
  },
  {
    id: 'kpi-completion',
    label: 'Completion Rate',
    value: '96.4%',
    sub: '-0.8% vs last week',
    trend: 'down',
    icon: CheckCircle,
    color: 'bg-muted text-muted-foreground',
    span: 'col-span-1',
  },
  {
    id: 'kpi-job-completion-history',
    label: 'Job Completion (30d)',
    value: '97.2%',
    sub: '+1.2% vs last month',
    trend: 'up',
    icon: CheckCircle,
    color: 'bg-success-bg text-success',
    span: 'col-span-1',
  },
  {
    id: 'kpi-cleaner-utilization',
    label: 'Cleaner Utilization',
    value: '78%',
    sub: '+5% vs last week',
    trend: 'up',
    icon: Users,
    color: 'bg-info-bg text-info',
    span: 'col-span-1',
  },
  {
    id: 'kpi-customer-retention',
    label: 'Customer Retention',
    value: '84%',
    sub: '+3% vs last quarter',
    trend: 'up',
    icon: Target,
    color: 'bg-primary/10 text-primary',
    span: 'col-span-1',
  },
  {
    id: 'kpi-revenue-forecast',
    label: 'Revenue Forecast (Q2)',
    value: '£89,400',
    sub: '+18% vs Q1',
    trend: 'up',
    icon: TrendingUp,
    color: 'bg-success-bg text-success',
    span: 'col-span-1 lg:col-span-2',
  },
];

export default function AdminKPIGrid() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4">
      {kpis?.map((kpi) => (
        <div
          key={kpi?.id}
          className={`bg-card rounded-2xl border card-shadow p-4 ${kpi?.span} ${kpi?.trend === 'alert' ? 'border-danger/30 bg-danger-bg/30' : 'border-border'}`}
        >
          <div className="flex items-start justify-between mb-3">
            <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{kpi?.label}</p>
            <div className={`w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0 ${kpi?.color}`}>
              <kpi.icon size={15} />
            </div>
          </div>
          <p className={`text-2xl font-extrabold font-tabular ${kpi?.trend === 'alert' ? 'text-danger' : 'text-foreground'}`}>{kpi?.value}</p>
          <p className={`text-xs mt-1 ${kpi?.trend === 'up' ? 'text-success' : kpi?.trend === 'down' ? 'text-danger' : kpi?.trend === 'alert' ? 'text-danger' : 'text-muted-foreground'}`}>
            {kpi?.trend === 'up' ? '↑ ' : kpi?.trend === 'down' ? '↓ ' : ''}{kpi?.sub}
          </p>
        </div>
      ))}
    </div>
  );
}